<template>
	<div class="feedback-container">	
        <!-- 页面标题 -->
        <div class="page-header">
            <h1 class="page-title">意见反馈</h1>
            <p class="page-subtitle">感谢您的宝贵意见，我们会认真处理</p>
        </div>

        <!-- 标签页 -->
        <div class="tab-section">
            <van-tabs v-model="activeTab" @click="changeTab" animated swipeable>
                <van-tab title="待处理">
                    <div class="tab-content">
                        <div class="result-count">
                            <van-icon name="search" class="count-icon" />
                            共有 {{rows}} 条记录
                        </div>
                    </div>
                </van-tab>
                <van-tab title="已回复">
                    <div class="tab-content">
                        <div class="result-count">
                            <van-icon name="search" class="count-icon" />
                            共有 {{rows}} 条记录
                        </div>
                    </div>
                </van-tab>
            </van-tabs>
        </div>

        <!-- 反馈列表 -->
        <div class="feedback-list">
            <div 
                class="feedback-card" 
                v-for="item in orderList" 
                :key="item.RecID"
                @click="itemClick(item.RecID)"
            >
                <div class="feedback-header">
                    <div class="feedback-left">
                        <van-icon name="comment" class="feedback-icon" />
                        <div class="feedback-info">
                            <h3 class="feedback-title">{{ item.MsgTitle }}</h3>
                            <span class="feedback-id">记录号：{{ item.RecID }}</span>
                        </div>
                    </div>
                    <van-tag :type="getStatusType(item.Status)" class="status-tag">
                        {{ item.Status }}
                    </van-tag>
                </div>
                
                <div class="feedback-content">
                    <p class="feedback-message">{{ item.Msg }}</p>
                </div>
                
                <div class="feedback-footer">
                    <div class="feedback-time">
                        <van-icon name="clock" class="time-icon" />
                        {{ item.SentTime }}
                    </div>
                    <van-icon name="arrow" class="arrow-icon" />
                </div>
            </div>
        </div>

        <!-- 空状态 -->
        <div v-if="orderList.length === 0" class="empty-state">
            <van-empty description="暂无反馈记录" image="search">
                <van-button 
                    round 
                    type="primary" 
                    class="new-feedback-btn"
                    @click="newOrder"
                >
                    新建反馈
                </van-button>
            </van-empty>
        </div>

        <!-- 底部新建按钮 -->
        <div class="footer-action">
            <van-button 
                type="primary" 
                size="large" 
                class="new-feedback-btn"
                @click="newOrder"
            >
                <van-icon name="add" class="btn-icon" />
                新建反馈
            </van-button>
        </div>
	</div>
</template>

<script>
	import Vue from 'vue'
	var access_token ="";
	export default {
	  name: 'FEEDBACK',	  
	  data(){
		  return{
			  feedback: require("@/assets/icon/feedback2.png"),
			  orderList:[],
			  rows:'0',
			  access_token,
              activeTab: 0
		  }
	  },
	  created(){		
		 var that = this;		
		 this.getData('待处理');		 
	  },
	  mounted(){
		document.title="意见反馈"
	  },
	  methods:{
         getStatusType(status) {
             const statusMap = {
                 '待处理': 'warning',
                 '已回复': 'success',
                 '处理中': 'primary'
             }
             return statusMap[status] || 'default'
         },		
		 getData(status){
			 var that = this;
			 var myUrl = that.global.BASE_URL_T3 + '/api/login2/mymessages?status=' + status;	
			 console.log(myUrl);
			 var config = {
			   method: 'get',
			   url: myUrl,
			   headers: { 
			     'Authorization': localStorage['access_token']
			   }
			 };
			 
			 Vue.axios(config)
			 .then(function (response) {				  
			   if (response.data.Status == 0)
			   {
			   	that.orderList = response.data.Data;
				that.rows = response.data.Data.length;
			   }	
				console.log(that.orderList);
			 })
			 .catch(function (error) {
			   console.log(error);
			 });			 
			},
		changeTab(name,title){
			this.getData(title);
		},
		newOrder(){
			this.$router.push({ path:'/feedback/newmsg'  })
		},
		itemClick(e){
			console.log(e)
			this.$root.common.curorderid = e;
            this.$router.push('feedback/msginfo');
		}		
		}	
	}
</script>

<style scoped>
.feedback-container {
    background-color: #f7f8fa;
    min-height: 100vh;
    padding-bottom: 80px;
}

.page-header {
    background-color: #ffffff;
    padding: 20px 16px;
    text-align: center;
    border-bottom: 1px solid #f0f0f0;
}

.page-title {
    font-size: 18px;
    font-weight: bold;
    color: #323233;
    margin-bottom: 4px;
}

.page-subtitle {
    font-size: 14px;
    color: #969799;
    margin: 0;
}

.tab-section {
    background-color: #ffffff;
    margin-bottom: 8px;
}

.tab-content {
    padding: 16px;
    background-color: #f7f8fa;
}

.result-count {
    background-color: #e6f7ff;
    border: 1px solid #91d5ff;
    border-radius: 6px;
    padding: 12px;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #1890ff;
}

.count-icon {
    margin-right: 8px;
    font-size: 16px;
}

.feedback-list {
    padding: 0 16px;
}

.feedback-card {
    background-color: #ffffff;
    border-radius: 12px;
    padding: 16px;
    margin-bottom: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
    border: 1px solid #f0f0f0;
    transition: all 0.3s ease;
    cursor: pointer;
}

.feedback-card:active {
    background-color: #f5f5f5;
    transform: scale(0.98);
}

.feedback-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 12px;
}

.feedback-left {
    display: flex;
    align-items: flex-start;
    flex: 1;
    min-width: 0;
}

.feedback-icon {
    color: #1989fa;
    font-size: 18px;
    margin-right: 12px;
    margin-top: 2px;
    flex-shrink: 0;
}

.feedback-info {
    flex: 1;
    min-width: 0;
	display: flex;
    align-items: flex-start;
}

.feedback-title {
    font-size: 15px;
    font-weight: bold;
    color: #323233;
    margin-bottom: 4px;
    line-height: 1.4;
    word-break: break-all;
}

.feedback-id {
    font-size: 12px;
    color: #969799;
}

.status-tag {
    margin-left: 8px;
    flex-shrink: 0;
}

.feedback-content {
    margin-bottom: 12px;
	display: flex;
    align-items: flex-start;
}

.feedback-message {
    font-size: 14px;
    color: #646566;
    line-height: 1.5;
    margin: 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.feedback-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #f5f5f5;
    padding-top: 12px;
}

.feedback-time {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #969799;
}

.time-icon {
    margin-right: 4px;
    font-size: 12px;
}

.arrow-icon {
    color: #969799;
    font-size: 14px;
}

.empty-state {
    padding: 40px 20px;
}

.footer-action {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 16px;
    background-color: #ffffff;
    border-top: 1px solid #f0f0f0;
}

.new-feedback-btn {
    border-radius: 8px;
}

.btn-icon {
    margin-right: 4px;
}
</style>